import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ContactForm as Form } from './components/Form'
import { PublicLayout, Title } from '../Customer/components/Styled'

export const ContactUs = () => {
  return (
    <PublicLayout>
      <div>
        <Title>
          <FormattedMessage
            id='contact.form.title'
          />
        </Title>
        <Form />
      </div>
    </PublicLayout>
  )
}
